// extracted by mini-css-extract-plugin
export default {"simpleAddressWrapper":"SimpleAddress-module--simple-address-wrapper--1aa36"};